export const TIME_ZONES = [
  {
    abbreviation: "ACDT",
    name: "Australian Central Daylight Saving Time",
    "UTC offset": "UTC+10:30",
  },
  {
    abbreviation: "ACST",
    name: "Australian Central Standard Time",
    "UTC offset": "UTC+09:30",
  },
  {
    abbreviation: "ACT",
    name: "Acre Time",
    "UTC offset": "UTC−05",
  },
  {
    abbreviation: "ACT",
    name: "ASEAN Common Time (proposed)",
    "UTC offset": "UTC+08:00",
  },
  {
    abbreviation: "ACWST",
    name: "Australian Central Western Standard Time (unofficial)",
    "UTC offset": "UTC+08:45",
  },
  {
    abbreviation: "ADT",
    name: "Atlantic Daylight Time",
    "UTC offset": "UTC−03",
  },
  {
    abbreviation: "AEDT",
    name: "Australian Eastern Daylight Saving Time",
    "UTC offset": "UTC+11",
  },
  {
    abbreviation: "AEST",
    name: "Australian Eastern Standard Time",
    "UTC offset": "UTC+10",
  },
  {
    abbreviation: "AET",
    name: "Australian Eastern Time",
    "UTC offset": "UTC+10/UTC+11",
  },
  {
    abbreviation: "AFT",
    name: "Afghanistan Time",
    "UTC offset": "UTC+04:30",
  },
  {
    abbreviation: "AKDT",
    name: "Alaska Daylight Time",
    "UTC offset": "UTC−08",
  },
  {
    abbreviation: "AKST",
    name: "Alaska Standard Time",
    "UTC offset": "UTC−09",
  },
  {
    abbreviation: "ALMT",
    name: "Alma-Ata Time",
    "UTC offset": "UTC+06",
  },
  {
    abbreviation: "AMST",
    name: "Amazon Summer Time (Brazil)",
    "UTC offset": "UTC−03",
  },
  {
    abbreviation: "AMT",
    name: "Amazon Time (Brazil)",
    "UTC offset": "UTC−04",
  },
  {
    abbreviation: "AMT",
    name: "Armenia Time",
    "UTC offset": "UTC+04",
  },
  {
    abbreviation: "ANAT",
    name: "Anadyr Time",
    "UTC offset": "UTC+12",
  },
  {
    abbreviation: "AQTT",
    name: "Aqtobe Time",
    "UTC offset": "UTC+05",
  },
  {
    abbreviation: "ART",
    name: "Argentina Time",
    "UTC offset": "UTC−03",
  },
  {
    abbreviation: "AST",
    name: "Arabia Standard Time",
    "UTC offset": "UTC+03",
  },
  {
    abbreviation: "AST",
    name: "Atlantic Standard Time",
    "UTC offset": "UTC−04",
  },
  {
    abbreviation: "AWST",
    name: "Australian Western Standard Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "AZOST",
    name: "Azores Summer Time",
    "UTC offset": "UTC±00",
  },
  {
    abbreviation: "AZOT",
    name: "Azores Standard Time",
    "UTC offset": "UTC−01",
  },
  {
    abbreviation: "AZT",
    name: "Azerbaijan Time",
    "UTC offset": "UTC+04",
  },
  {
    abbreviation: "BNT",
    name: "Brunei Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "BIOT",
    name: "British Indian Ocean Time",
    "UTC offset": "UTC+06",
  },
  {
    abbreviation: "BIT",
    name: "Baker Island Time",
    "UTC offset": "UTC−12",
  },
  {
    abbreviation: "BOT",
    name: "Bolivia Time",
    "UTC offset": "UTC−04",
  },
  {
    abbreviation: "BRST",
    name: "Brasília Summer Time",
    "UTC offset": "UTC−02",
  },
  {
    abbreviation: "BRT",
    name: "Brasília Time",
    "UTC offset": "UTC−03",
  },
  {
    abbreviation: "BST",
    name: "Bangladesh Standard Time",
    "UTC offset": "UTC+06",
  },
  {
    abbreviation: "BST",
    name: "Bougainville Standard Time",
    "UTC offset": "UTC+11",
  },
  {
    abbreviation: "BST",
    name: "British Summer Time (British Standard Time from Feb 1968 to Oct 1971)",
    "UTC offset": "UTC+01",
  },
  {
    abbreviation: "BTT",
    name: "Bhutan Time",
    "UTC offset": "UTC+06",
  },
  {
    abbreviation: "CAT",
    name: "Central Africa Time",
    "UTC offset": "UTC+02",
  },
  {
    abbreviation: "CCT",
    name: "Cocos Islands Time",
    "UTC offset": "UTC+06:30",
  },
  {
    abbreviation: "CDT",
    name: "Central Daylight Time (North America)",
    "UTC offset": "UTC−05",
  },
  {
    abbreviation: "CDT",
    name: "Cuba Daylight Time",
    "UTC offset": "UTC−04",
  },
  {
    abbreviation: "CEST",
    name: "Central European Summer Time",
    "UTC offset": "UTC+02",
  },
  {
    abbreviation: "CET",
    name: "Central European Time",
    "UTC offset": "UTC+01",
  },
  {
    abbreviation: "CHADT",
    name: "Chatham Daylight Time",
    "UTC offset": "UTC+13:45",
  },
  {
    abbreviation: "CHAST",
    name: "Chatham Standard Time",
    "UTC offset": "UTC+12:45",
  },
  {
    abbreviation: "CHOT",
    name: "Choibalsan Standard Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "CHOST",
    name: "Choibalsan Summer Time",
    "UTC offset": "UTC+09",
  },
  {
    abbreviation: "CHST",
    name: "Chamorro Standard Time",
    "UTC offset": "UTC+10",
  },
  {
    abbreviation: "CHUT",
    name: "Chuuk Time",
    "UTC offset": "UTC+10",
  },
  {
    abbreviation: "CIST",
    name: "Clipperton Island Standard Time",
    "UTC offset": "UTC−08",
  },
  {
    abbreviation: "CKT",
    name: "Cook Island Time",
    "UTC offset": "UTC−10",
  },
  {
    abbreviation: "CLST",
    name: "Chile Summer Time",
    "UTC offset": "UTC−03",
  },
  {
    abbreviation: "CLT",
    name: "Chile Standard Time",
    "UTC offset": "UTC−04",
  },
  {
    abbreviation: "COST",
    name: "Colombia Summer Time",
    "UTC offset": "UTC−04",
  },
  {
    abbreviation: "COT",
    name: "Colombia Time",
    "UTC offset": "UTC−05",
  },
  {
    abbreviation: "CST",
    name: "Central Standard Time (North America)",
    "UTC offset": "UTC−06",
  },
  {
    abbreviation: "CST",
    name: "China Standard Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "CST",
    name: "Cuba Standard Time",
    "UTC offset": "UTC−05",
  },
  {
    abbreviation: "CT",
    name: "Central Time",
    "UTC offset": "UTC−06/UTC−05",
  },
  {
    abbreviation: "CVT",
    name: "Cape Verde Time",
    "UTC offset": "UTC−01",
  },
  {
    abbreviation: "CWST",
    name: "Central Western Standard Time (Australia) unofficial",
    "UTC offset": "UTC+08:45",
  },
  {
    abbreviation: "CXT",
    name: "Christmas Island Time",
    "UTC offset": "UTC+07",
  },
  {
    abbreviation: "DAVT",
    name: "Davis Time",
    "UTC offset": "UTC+07",
  },
  {
    abbreviation: "DDUT",
    name: "Dumont d'Urville Time",
    "UTC offset": "UTC+10",
  },
  {
    abbreviation: "DFT",
    name: "AIX-specific equivalent of Central European Time",
    "UTC offset": "UTC+01",
  },
  {
    abbreviation: "EASST",
    name: "Easter Island Summer Time",
    "UTC offset": "UTC−05",
  },
  {
    abbreviation: "EAST",
    name: "Easter Island Standard Time",
    "UTC offset": "UTC−06",
  },
  {
    abbreviation: "EAT",
    name: "East Africa Time",
    "UTC offset": "UTC+03",
  },
  {
    abbreviation: "ECT",
    name: "Eastern Caribbean Time (does not recognise DST)",
    "UTC offset": "UTC−04",
  },
  {
    abbreviation: "ECT",
    name: "Ecuador Time",
    "UTC offset": "UTC−05",
  },
  {
    abbreviation: "EDT",
    name: "Eastern Daylight Time (North America)",
    "UTC offset": "UTC−04",
  },
  {
    abbreviation: "EEST",
    name: "Eastern European Summer Time",
    "UTC offset": "UTC+03",
  },
  {
    abbreviation: "EET",
    name: "Eastern European Time",
    "UTC offset": "UTC+02",
  },
  {
    abbreviation: "EGST",
    name: "Eastern Greenland Summer Time",
    "UTC offset": "UTC±00",
  },
  {
    abbreviation: "EGT",
    name: "Eastern Greenland Time",
    "UTC offset": "UTC−01",
  },
  {
    abbreviation: "EST",
    name: "Eastern Standard Time (North America)",
    "UTC offset": "UTC−05",
  },
  {
    abbreviation: "ET",
    name: "Eastern Time Zone",
    "UTC offset": "UTC−05 / UTC−04",
  },
  {
    abbreviation: "FET",
    name: "Further-eastern European Time",
    "UTC offset": "UTC+03",
  },
  {
    abbreviation: "FJT",
    name: "Fiji Time",
    "UTC offset": "UTC+12",
  },
  {
    abbreviation: "FKST",
    name: "Falkland Islands Summer Time",
    "UTC offset": "UTC−03",
  },
  {
    abbreviation: "FKT",
    name: "Falkland Islands Time",
    "UTC offset": "UTC−04",
  },
  {
    abbreviation: "FNT",
    name: "Fernando de Noronha Time",
    "UTC offset": "UTC−02",
  },
  {
    abbreviation: "GALT",
    name: "Galápagos Time",
    "UTC offset": "UTC−06",
  },
  {
    abbreviation: "GAMT",
    name: "Gambier Islands Time",
    "UTC offset": "UTC−09",
  },
  {
    abbreviation: "GET",
    name: "Georgia Standard Time",
    "UTC offset": "UTC+04",
  },
  {
    abbreviation: "GFT",
    name: "French Guiana Time",
    "UTC offset": "UTC−03",
  },
  {
    abbreviation: "GILT",
    name: "Gilbert Island Time",
    "UTC offset": "UTC+12",
  },
  {
    abbreviation: "GIT",
    name: "Gambier Island Time",
    "UTC offset": "UTC−09",
  },
  {
    abbreviation: "GMT",
    name: "Greenwich Mean Time",
    "UTC offset": "UTC±00",
  },
  {
    abbreviation: "GST",
    name: "South Georgia and the South Sandwich Islands Time",
    "UTC offset": "UTC−02",
  },
  {
    abbreviation: "GST",
    name: "Gulf Standard Time",
    "UTC offset": "UTC+04",
  },
  {
    abbreviation: "GYT",
    name: "Guyana Time",
    "UTC offset": "UTC−04",
  },
  {
    abbreviation: "HDT",
    name: "Hawaii–Aleutian Daylight Time",
    "UTC offset": "UTC−09",
  },
  {
    abbreviation: "HAEC",
    name: "Heure Avancée d'Europe Centrale French-language name for CEST",
    "UTC offset": "UTC+02",
  },
  {
    abbreviation: "HST",
    name: "Hawaii–Aleutian Standard Time",
    "UTC offset": "UTC−10",
  },
  {
    abbreviation: "HKT",
    name: "Hong Kong Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "HMT",
    name: "Heard and McDonald Islands Time",
    "UTC offset": "UTC+05",
  },
  {
    abbreviation: "HOVST",
    name: "Hovd Summer Time (not used from 2017-present)",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "HOVT",
    name: "Hovd Time",
    "UTC offset": "UTC+07",
  },
  {
    abbreviation: "ICT",
    name: "Indochina Time",
    "UTC offset": "UTC+07",
  },
  {
    abbreviation: "IDLW",
    name: "International Day Line West time zone",
    "UTC offset": "UTC−12",
  },
  {
    abbreviation: "IDT",
    name: "Israel Daylight Time",
    "UTC offset": "UTC+03",
  },
  {
    abbreviation: "IOT",
    name: "Indian Ocean Time",
    "UTC offset": "UTC+03",
  },
  {
    abbreviation: "IRDT",
    name: "Iran Daylight Time",
    "UTC offset": "UTC+04:30",
  },
  {
    abbreviation: "IRKT",
    name: "Irkutsk Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "IRST",
    name: "Iran Standard Time",
    "UTC offset": "UTC+03:30",
  },
  {
    abbreviation: "IST",
    name: "Indian Standard Time",
    "UTC offset": "UTC+05:30",
  },
  {
    abbreviation: "IST",
    name: "Irish Standard Time",
    "UTC offset": "UTC+01",
  },
  {
    abbreviation: "IST",
    name: "Israel Standard Time",
    "UTC offset": "UTC+02",
  },
  {
    abbreviation: "JST",
    name: "Japan Standard Time",
    "UTC offset": "UTC+09",
  },
  {
    abbreviation: "KALT",
    name: "Kaliningrad Time",
    "UTC offset": "UTC+02",
  },
  {
    abbreviation: "KGT",
    name: "Kyrgyzstan Time",
    "UTC offset": "UTC+06",
  },
  {
    abbreviation: "KOST",
    name: "Kosrae Time",
    "UTC offset": "UTC+11",
  },
  {
    abbreviation: "KRAT",
    name: "Krasnoyarsk Time",
    "UTC offset": "UTC+07",
  },
  {
    abbreviation: "KST",
    name: "Korea Standard Time",
    "UTC offset": "UTC+09",
  },
  {
    abbreviation: "LHST",
    name: "Lord Howe Standard Time",
    "UTC offset": "UTC+10:30",
  },
  {
    abbreviation: "LHST",
    name: "Lord Howe Summer Time",
    "UTC offset": "UTC+11",
  },
  {
    abbreviation: "LINT",
    name: "Line Islands Time",
    "UTC offset": "UTC+14",
  },
  {
    abbreviation: "MAGT",
    name: "Magadan Time",
    "UTC offset": "UTC+12",
  },
  {
    abbreviation: "MART",
    name: "Marquesas Islands Time",
    "UTC offset": "UTC−09:30",
  },
  {
    abbreviation: "MAWT",
    name: "Mawson Station Time",
    "UTC offset": "UTC+05",
  },
  {
    abbreviation: "MDT",
    name: "Mountain Daylight Time (North America)",
    "UTC offset": "UTC−06",
  },
  {
    abbreviation: "MET",
    name: "Middle European Time (same zone as CET)",
    "UTC offset": "UTC+01",
  },
  {
    abbreviation: "MEST",
    name: "Middle European Summer Time (same zone as CEST)",
    "UTC offset": "UTC+02",
  },
  {
    abbreviation: "MHT",
    name: "Marshall Islands Time",
    "UTC offset": "UTC+12",
  },
  {
    abbreviation: "MIST",
    name: "Macquarie Island Station Time",
    "UTC offset": "UTC+11",
  },
  {
    abbreviation: "MMT",
    name: "Myanmar Standard Time",
    "UTC offset": "UTC+06:30",
  },
  {
    abbreviation: "MSK",
    name: "Moscow Time",
    "UTC offset": "UTC+03",
  },
  {
    abbreviation: "MST",
    name: "Malaysia Standard Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "MST",
    name: "Mountain Standard Time (North America)",
    "UTC offset": "UTC−07",
  },
  {
    abbreviation: "MUT",
    name: "Mauritius Time",
    "UTC offset": "UTC+04",
  },
  {
    abbreviation: "MVT",
    name: "Maldives Time",
    "UTC offset": "UTC+05",
  },
  {
    abbreviation: "MYT",
    name: "Malaysia Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "NCT",
    name: "New Caledonia Time",
    "UTC offset": "UTC+11",
  },
  {
    abbreviation: "NDT",
    name: "Newfoundland Daylight Time",
    "UTC offset": "UTC−02:30",
  },
  {
    abbreviation: "NFT",
    name: "Norfolk Island Time",
    "UTC offset": "UTC+11",
  },
  {
    abbreviation: "NOVT",
    name: "Novosibirsk Time ",
    "UTC offset": "UTC+07",
  },
  {
    abbreviation: "NPT",
    name: "Nepal Time",
    "UTC offset": "UTC+05:45",
  },
  {
    abbreviation: "NST",
    name: "Newfoundland Standard Time",
    "UTC offset": "UTC−03:30",
  },
  {
    abbreviation: "NT",
    name: "Newfoundland Time",
    "UTC offset": "UTC−03:30",
  },
  {
    abbreviation: "NUT",
    name: "Niue Time",
    "UTC offset": "UTC−11",
  },
  {
    abbreviation: "NZDT",
    name: "New Zealand Daylight Time",
    "UTC offset": "UTC+13",
  },
  {
    abbreviation: "NZST",
    name: "New Zealand Standard Time",
    "UTC offset": "UTC+12",
  },
  {
    abbreviation: "OMST",
    name: "Omsk Time",
    "UTC offset": "UTC+06",
  },
  {
    abbreviation: "ORAT",
    name: "Oral Time",
    "UTC offset": "UTC+05",
  },
  {
    abbreviation: "PDT",
    name: "Pacific Daylight Time (North America)",
    "UTC offset": "UTC−07",
  },
  {
    abbreviation: "PET",
    name: "Peru Time",
    "UTC offset": "UTC−05",
  },
  {
    abbreviation: "PETT",
    name: "Kamchatka Time",
    "UTC offset": "UTC+12",
  },
  {
    abbreviation: "PGT",
    name: "Papua New Guinea Time",
    "UTC offset": "UTC+10",
  },
  {
    abbreviation: "PHOT",
    name: "Phoenix Island Time",
    "UTC offset": "UTC+13",
  },
  {
    abbreviation: "PHT",
    name: "Philippine Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "PHST",
    name: "Philippine Standard Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "PKT",
    name: "Pakistan Standard Time",
    "UTC offset": "UTC+05",
  },
  {
    abbreviation: "PMDT",
    name: "Saint Pierre and Miquelon Daylight Time",
    "UTC offset": "UTC−02",
  },
  {
    abbreviation: "PMST",
    name: "Saint Pierre and Miquelon Standard Time",
    "UTC offset": "UTC−03",
  },
  {
    abbreviation: "PONT",
    name: "Pohnpei Standard Time",
    "UTC offset": "UTC+11",
  },
  {
    abbreviation: "PST",
    name: "Pacific Standard Time (North America)",
    "UTC offset": "UTC−08",
  },
  {
    abbreviation: "PWT",
    name: "Palau Time",
    "UTC offset": "UTC+09",
  },
  {
    abbreviation: "PYST",
    name: "Paraguay Summer Time",
    "UTC offset": "UTC−03",
  },
  {
    abbreviation: "PYT",
    name: "Paraguay Time",
    "UTC offset": "UTC−04",
  },
  {
    abbreviation: "RET",
    name: "Réunion Time",
    "UTC offset": "UTC+04",
  },
  {
    abbreviation: "ROTT",
    name: "Rothera Research Station Time",
    "UTC offset": "UTC−03",
  },
  {
    abbreviation: "SAKT",
    name: "Sakhalin Island Time",
    "UTC offset": "UTC+11",
  },
  {
    abbreviation: "SAMT",
    name: "Samara Time",
    "UTC offset": "UTC+04",
  },
  {
    abbreviation: "SAST",
    name: "South African Standard Time",
    "UTC offset": "UTC+02",
  },
  {
    abbreviation: "SBT",
    name: "Solomon Islands Time",
    "UTC offset": "UTC+11",
  },
  {
    abbreviation: "SCT",
    name: "Seychelles Time",
    "UTC offset": "UTC+04",
  },
  {
    abbreviation: "SDT",
    name: "Samoa Daylight Time",
    "UTC offset": "UTC−10",
  },
  {
    abbreviation: "SGT",
    name: "Singapore Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "SLST",
    name: "Sri Lanka Standard Time",
    "UTC offset": "UTC+05:30",
  },
  {
    abbreviation: "SRET",
    name: "Srednekolymsk Time",
    "UTC offset": "UTC+11",
  },
  {
    abbreviation: "SRT",
    name: "Suriname Time",
    "UTC offset": "UTC−03",
  },
  {
    abbreviation: "SST",
    name: "Samoa Standard Time",
    "UTC offset": "UTC−11",
  },
  {
    abbreviation: "SST",
    name: "Singapore Standard Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "SYOT",
    name: "Showa Station Time",
    "UTC offset": "UTC+03",
  },
  {
    abbreviation: "TAHT",
    name: "Tahiti Time",
    "UTC offset": "UTC−10",
  },
  {
    abbreviation: "THA",
    name: "Thailand Standard Time",
    "UTC offset": "UTC+07",
  },
  {
    abbreviation: "TFT",
    name: "French Southern and Antarctic Time",
    "UTC offset": "UTC+05",
  },
  {
    abbreviation: "TJT",
    name: "Tajikistan Time",
    "UTC offset": "UTC+05",
  },
  {
    abbreviation: "TKT",
    name: "Tokelau Time",
    "UTC offset": "UTC+13",
  },
  {
    abbreviation: "TLT",
    name: "Timor Leste Time",
    "UTC offset": "UTC+09",
  },
  {
    abbreviation: "TMT",
    name: "Turkmenistan Time",
    "UTC offset": "UTC+05",
  },
  {
    abbreviation: "TRT",
    name: "Turkey Time",
    "UTC offset": "UTC+03",
  },
  {
    abbreviation: "TOT",
    name: "Tonga Time",
    "UTC offset": "UTC+13",
  },
  {
    abbreviation: "TVT",
    name: "Tuvalu Time",
    "UTC offset": "UTC+12",
  },
  {
    abbreviation: "ULAST",
    name: "Ulaanbaatar Summer Time",
    "UTC offset": "UTC+09",
  },
  {
    abbreviation: "ULAT",
    name: "Ulaanbaatar Standard Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "UTC",
    name: "Coordinated Universal Time",
    "UTC offset": "UTC±00",
  },
  {
    abbreviation: "UYST",
    name: "Uruguay Summer Time",
    "UTC offset": "UTC−02",
  },
  {
    abbreviation: "UYT",
    name: "Uruguay Standard Time",
    "UTC offset": "UTC−03",
  },
  {
    abbreviation: "UZT",
    name: "Uzbekistan Time",
    "UTC offset": "UTC+05",
  },
  {
    abbreviation: "VET",
    name: "Venezuelan Standard Time",
    "UTC offset": "UTC−04",
  },
  {
    abbreviation: "VLAT",
    name: "Vladivostok Time",
    "UTC offset": "UTC+10",
  },
  {
    abbreviation: "VOLT",
    name: "Volgograd Time",
    "UTC offset": "UTC+03",
  },
  {
    abbreviation: "VOST",
    name: "Vostok Station Time",
    "UTC offset": "UTC+06",
  },
  {
    abbreviation: "VUT",
    name: "Vanuatu Time",
    "UTC offset": "UTC+11",
  },
  {
    abbreviation: "WAKT",
    name: "Wake Island Time",
    "UTC offset": "UTC+12",
  },
  {
    abbreviation: "WAST",
    name: "West Africa Summer Time",
    "UTC offset": "UTC+02",
  },
  {
    abbreviation: "WAT",
    name: "West Africa Time",
    "UTC offset": "UTC+01",
  },
  {
    abbreviation: "WEST",
    name: "Western European Summer Time",
    "UTC offset": "UTC+01",
  },
  {
    abbreviation: "WET",
    name: "Western European Time",
    "UTC offset": "UTC±00",
  },
  {
    abbreviation: "WIB",
    name: "Western Indonesian Time",
    "UTC offset": "UTC+07",
  },
  {
    abbreviation: "WIT",
    name: "Eastern Indonesian Time",
    "UTC offset": "UTC+09",
  },
  {
    abbreviation: "WITA",
    name: "Central Indonesia Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "WGST",
    name: "West Greenland Summer Time",
    "UTC offset": "UTC−02",
  },
  {
    abbreviation: "WGT",
    name: "West Greenland Time",
    "UTC offset": "UTC−03",
  },
  {
    abbreviation: "WST",
    name: "Western Standard Time",
    "UTC offset": "UTC+08",
  },
  {
    abbreviation: "YAKT",
    name: "Yakutsk Time",
    "UTC offset": "UTC+09",
  },
  {
    abbreviation: "YEKT",
    name: "Yekaterinburg Time",
    "UTC offset": "UTC+05",
  },
];

export const DATE_FORMAT = "DD/MM/YYYY";

export const TIME_FORMAT = "hh:mm A";

export const TIME_PERIODS = ["AM", "PM"];
